import type { IMessageDomainService } from "./message-domain-service.interface";
import type {
	IMessageEntity,
	ITextMessageEntity,
	IStickerMessageEntity,
} from "../../shared/entities";

import { TextMessageEntityClass } from "../../domain/entites/text-message";
import { StickerMessageEntityClass } from "../../domain/entites/sticker-message";

import { messageRepository } from "../../repo/message";

class MessageDomainService implements IMessageDomainService {

	public async sendMessage(message: IMessageEntity): Promise<IMessageEntity> {
		throw new Error("Not implemented yet!");
	}

	public async sendNewTextMessage(message: ITextMessageEntity): Promise<ITextMessageEntity> {
		const textMessageEntity = new TextMessageEntityClass(
			message.type,
			message.content,
			message.msgId,
			message.cliMsgId,
			message.fromUid,
			message.toUid,
			message.sendDttm,
		);
		textMessageEntity.updateTtl(-1);
		textMessageEntity.updateLocalDttm(message.localDttm ?? message.sendDttm);
		textMessageEntity.updateUrgency(null);
		textMessageEntity.updateE2eeStatus(-1);

		const saved = await messageRepository.saveNewTextMessage(textMessageEntity.toPlainObject());
		return saved;
	}

	public async sendNewStickerMessage(
		message: IStickerMessageEntity,
	): Promise<IStickerMessageEntity> {
		const stickerMessageEntity = new StickerMessageEntityClass(
			message.type,
			message.content,
			message.msgId,
			message.cliMsgId,
			message.fromUid,
			message.toUid,
			message.sendDttm,
		);
		stickerMessageEntity.updateTtl(-1);
		stickerMessageEntity.updateLocalDttm(message.localDttm ?? message.sendDttm);
		stickerMessageEntity.updateUrgency(null);
		stickerMessageEntity.updateE2eeStatus(-1);

		const saved = await messageRepository.saveNewStickerMessage(
			stickerMessageEntity.toPlainObject(),
		);
		return saved;
	}
}

const messageDomainService = new MessageDomainService();
export default messageDomainService;
